import { render, staticRenderFns } from "./avisoInicio.vue?vue&type=template&id=7453ae88&"
import script from "./avisoInicio.vue?vue&type=script&lang=js&"
export * from "./avisoInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports